import React from 'react';
import { Helmet } from 'react-helmet';
import i18n from 'react-intl-universal';
import Facebook from './Facebook';
import Twitter from './Twitter';
import { connect } from 'react-redux';
import logo from '../../../assets/images/logo.svg';

const SEOMeta = ({ siteLanguage, title, desc, banner, pathname }) => {
  const siteName = i18n.get('app.siteName');
  const siteSlogan = i18n.get('app.siteSlogan');
  const siteTitle = title
    ? `${title} | ${siteName}`
    : `${siteName} - ${siteSlogan}`;

  const seo = {
    title: siteTitle,
    description: desc || siteSlogan,
    image: `${process.env.PUBLIC_URL}${banner || logo}`,
    url: `${pathname || process.env.PUBLIC_URL}`
  };

  //TODO: add Google's schemaOrgJSONLD
  // example: https://github.com/LekoArts/gatsby-starter-prismic/blob/master/src/components/SEO/SEO.jsx

  return (
    <React.Fragment>
      <Helmet>
        <html lang={siteLanguage} />
        <meta name="description" content={seo.description} />
        <meta name="image" content={seo.image} />
        <meta name="apple-mobile-web-app-title" content={siteName} />
        <meta name="application-name" content={siteName} />
        <title>{seo.title}</title>
      </Helmet>
      <Facebook
        desc={seo.description}
        image={seo.image}
        title={seo.title}
        type={null}
        url={seo.url}
      />
      <Twitter
        title={seo.title}
        image={seo.image}
        desc={seo.description}
        username={'@codemarshalsys'}
      />
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  siteLanguage: state.i18n.currentLocale
});
export default connect(
  mapStateToProps,
  null
)(SEOMeta);
